module.exports = __webpack_public_path__ + "img/account-image.aee4b422.svg";